export default (api) => {
    return {
        index: options => api.get('polls', options),
        votes: (lesson_id, poll_id, options) => api.get(`lessons/${lesson_id}/poll/${poll_id}/votes`, options),
        vote: (lesson_id, stream_id, stream_entity_id, poll_id, data, options) => api.post(`lessons/${lesson_id}/stream/${stream_id}/stream_entity/${stream_entity_id}/poll/${poll_id}/vote`, data, options),
        winner: (lesson_id, stream_entity_id, options) => api.get(`lessons/${lesson_id}/stream_entity/${stream_entity_id}/winner`, options)
    };
}
